import React from 'react';
import SEO from '../../components/SEO/SEO';

import '../Privacy/Privacy.css';

const Terms = () => {
    return (
        <div className="legal-page">
            <SEO
                title="Terms Services | Digi Network"
                description="Learn more about our Terms services to grow your business online with Digi Network."
                canonical="/terms/terms"
            />

            <section className="legal-hero">
                <div className="container">
                    <div className="legal-hero-content">
                        <div className="label">Legal</div>
                        <h1>Terms of Service</h1>
                        {/* <p className="legal-updated">Last Updated: January 15, 2025</p> */}
                    </div>
                </div>
            </section>

            <section className="legal-content">
                <div className="container">
                    <div className="legal-wrapper">
                        <div className="legal-section">
                            <h2>1. Agreement to Terms</h2>
                            <p>By accessing or using the Marketing Pro website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing our services.</p>
                        </div>

                        <div className="legal-section">
                            <h2>2. Services Description</h2>
                            <p>Marketing Pro provides digital marketing services including but not limited to:</p>
                            <ul>
                                <li>Search Engine Optimization (SEO)</li>
                                <li>Pay-Per-Click (PPC) Advertising</li>
                                <li>Web Design and Development</li>
                                {/* <li>Social Media Marketing</li> */}
                                <li>Email Marketing</li>
                                <li>Analytics and Reporting</li>
                            </ul>
                            <p>The specific services provided will be outlined in individual service agreements or proposals.</p>
                        </div>

                        <div className="legal-section">
                            <h2>3. User Obligations</h2>
                            <p>When using our services, you agree to:</p>
                            <ul>
                                <li>Provide accurate, current, and complete information</li>
                                <li>Maintain the security of your account credentials</li>
                                <li>Notify us immediately of any unauthorized use</li>
                                <li>Comply with all applicable laws and regulations</li>
                                <li>Not use our services for any illegal or unauthorized purpose</li>
                                <li>Not interfere with or disrupt our services or servers</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>4. Service Agreements and Contracts</h2>
                            <h3>Contract Terms</h3>
                            <p>Individual service contracts will specify:</p>
                            <ul>
                                <li>Scope of services to be provided</li>
                                <li>Pricing and payment terms</li>
                                <li>Contract duration and renewal terms</li>
                                <li>Performance expectations and deliverables</li>
                            </ul>

                            <h3>Payment Terms</h3>
                            <ul>
                                <li>Payment is due according to the terms specified in your service agreement</li>
                                <li>Late payments may incur additional fees</li>
                                <li>Services may be suspended for non-payment</li>
                                <li>All fees are non-refundable unless otherwise stated</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>5. Intellectual Property Rights</h2>
                            <h3>Our Property</h3>
                            <p>All content on our website, including text, graphics, logos, images, and software, is the property of Marketing Pro or its licensors and is protected by copyright and other intellectual property laws.</p>

                            <h3>Client Property</h3>
                            <p>You retain ownership of any materials you provide to us. By providing materials, you grant us a license to use them for the purpose of delivering our services.</p>

                            <h3>Work Product</h3>
                            <p>Ownership of work product created under a service agreement will be specified in that agreement.</p>
                        </div>

                        <div className="legal-section">
                            <h2>6. Confidentiality</h2>
                            <p>Both parties agree to:</p>
                            <ul>
                                <li>Keep confidential information private and secure</li>
                                <li>Not disclose confidential information to third parties</li>
                                <li>Use confidential information only for the purpose of the business relationship</li>
                                <li>Return or destroy confidential information upon request or termination</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>7. Warranties and Disclaimers</h2>
                            <h3>Service Warranties</h3>
                            <p>We warrant that our services will be performed in a professional manner consistent with industry standards.</p>

                            <h3>Disclaimers</h3>
                            <p>EXCEPT AS EXPRESSLY PROVIDED, OUR SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT GUARANTEE SPECIFIC RESULTS FROM OUR MARKETING SERVICES.</p>
                        </div>

                        <div className="legal-section">
                            <h2>8. Limitation of Liability</h2>
                            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
                            <ul>
                                <li>We shall not be liable for any indirect, incidental, special, or consequential damages</li>
                                <li>Our total liability shall not exceed the amount paid by you for services in the 12 months preceding the claim</li>
                                <li>We are not liable for results beyond our control, including search engine algorithm changes</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>9. Termination</h2>
                            <h3>Termination by Either Party</h3>
                            <p>Either party may terminate a service agreement according to the terms specified in that agreement.</p>

                            <h3>Effect of Termination</h3>
                            <ul>
                                <li>All outstanding payments become immediately due</li>
                                <li>We will provide final reports and deliverables as specified</li>
                                <li>Confidentiality obligations continue after termination</li>
                                <li>Certain provisions of these terms survive termination</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>10. Indemnification</h2>
                            <p>You agree to indemnify and hold harmless Marketing Pro from any claims, damages, or expenses arising from:</p>
                            <ul>
                                <li>Your use of our services</li>
                                <li>Your violation of these terms</li>
                                <li>Your violation of any third-party rights</li>
                                <li>Content or materials you provide to us</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>11. Dispute Resolution</h2>
                            <h3>Governing Law</h3>
                            <p>These terms are governed by the laws of the State of New York, without regard to conflict of law provisions.</p>

                            <h3>Arbitration</h3>
                            <p>Any disputes shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.</p>
                        </div>

                        <div className="legal-section">
                            <h2>12. Changes to Terms</h2>
                            <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of our services constitutes acceptance of the modified terms.</p>
                        </div>

                        <div className="legal-section">
                            <h2>13. General Provisions</h2>
                            <h3>Entire Agreement</h3>
                            <p>These terms, together with any service agreements, constitute the entire agreement between you and Marketing Pro.</p>

                            <h3>Severability</h3>
                            <p>If any provision is found to be unenforceable, the remaining provisions will continue in full force.</p>

                            <h3>Waiver</h3>
                            <p>No waiver of any term shall be deemed a further or continuing waiver of such term or any other term.</p>
                        </div>

                        <div className="legal-section">
                            <h2>14. Contact Information</h2>
                            <p>For questions about these Terms of Service, please contact us:</p>
                            <div className="contact-info-legal">
                                <p><strong>Email:</strong> ali@diginetworkads.com</p>
                                <p><strong>Phone:</strong> +92 300 4817173</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Terms;
